import { TranslateService } from '@ngx-translate/core';

export interface IError {
    text: string | (() => string);
    isCritical?: boolean;
    obj: Error;
    timer?: number;
}

export function getErrorText(text: string | (() => string), translate?: TranslateService): string {
    if (typeof text === 'string') {
        return translate ? translate.instant(text) || text : text;
    }
    return text();
}
